import React from 'react';
import {Box, IconButton, Link, Paper, Tooltip, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {useCorporationsOfDomainQuery} from '../../../graphql/graphql.types';
import OpenInNewTabIcon from '../../../assets/icons/open-in-new-tab.svg';
import {lang} from '../../../lang/lang';

const useStyles = makeStyles((theme) => ({
    url: {
        wordBreak: 'break-all',
    },
    openInNewTab: {
        marginLeft: theme.spacing(0.5),
        '& svg': {
            fill: theme.palette.primary.main,
            opacity: 0.7,
        },
        '&:hover svg': {
            fill: theme.palette.secondary.dark,
            opacity: 1,
        },
    },
}));

type Props = {
    domain: string;
};

export const DomainCorporations = ({domain}: Props) => {
    const classes = useStyles();
    const {data} = useCorporationsOfDomainQuery({variables: {domain}});
    const corporations = data?.corporationsOfDomain || [];

    if (corporations.length === 0) {
        return null;
    }

    return (
        <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                {lang.domain.corporations.title}
            </Typography>
            {corporations.map(({id, nameJp, nameEn, corporateNumber, homepageUrl}) => (
                <Box component={Paper} key={id} mb={1} p={2}>
                    <Typography variant="subtitle1">{nameJp}</Typography>
                    {nameEn && <Typography variant="body2" color="textSecondary">{nameEn}</Typography>}
                    {corporateNumber && (
                        <Typography variant="body2">
                            {lang.domain.corporations.corporateNumber}: {corporateNumber}
                        </Typography>
                    )}
                    <Box alignItems="center" display="flex">
                        <Typography className={classes.url} variant="body2">
                            {lang.domain.corporations.companyPage}:{' '}
                            <Link href={homepageUrl} target="_blank" rel="noopener noreferrer">
                                {homepageUrl}
                            </Link>
                        </Typography>
                        <Tooltip
                            arrow
                            className={classes.openInNewTab}
                            title={lang.domain.link.openInNewTab}
                            placement="bottom-end"
                        >
                            <IconButton
                                component="a"
                                href={homepageUrl}
                                rel="noopener noreferrer"
                                size="small"
                                target="_blank"
                            >
                                <OpenInNewTabIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};
